<header class="header">
    <div class="container">
        <div class="logo-wrapper">
            <img class="img-fluid" src="/assets/logo-white.svg" alt="bizerba-logo"/>
        </div> 
    </div>
</header>
